export default __webpack_public_path__ + "static/media/259-european-union.82fa986a.svg";